module.exports = __webpack_public_path__ + "static/img/CR.6aaacd96.png";